import { format, parseISO } from 'date-fns';

import { UserStatusApiResponse } from 'routes/referral/types/user-status-api.types';

const formatDateUtc = (dateString: string): string => {
  const date = parseISO(dateString);
  return `${format(date, 'yyyy-MM-dd HH:mm')} UTC`;
};

export const getRegistrationDateDisplay = (userStatus?: UserStatusApiResponse): string => {
  if (!userStatus) return '-';

  if (userStatus.status === 'REGISTERED' || userStatus.status === 'AWAITING_DISTRIBUTION' || userStatus.status === 'DISTRIBUTED') {
    return userStatus.registered_at ? formatDateUtc(userStatus.registered_at) : '-';
  }

  if (userStatus.status === 'NOT_REGISTERED' && userStatus.unregistered_at) {
    return formatDateUtc(userStatus.unregistered_at);
  }

  return '-';
};
